module.exports = __webpack_public_path__ + "static/media/mic.539180e2.jpeg";